import { AuthRepository } from 'application/repositories/AuthRepository';
import { SignInData, SignUpData, VerifyData, VerifyRegisterData } from 'domain/entities/AuthEntity';
import { MemberBasicInfoResult } from 'domain/entities/UserEntity';

export class AuthUseCase implements AuthUseCaseInterface {
    private authRepo: AuthRepository;

    constructor(authenRepo: AuthRepository) {
        this.authRepo = authenRepo;
    }

    async signin(data: SignInData): Promise<any> {
        return await this.authRepo.signin(data);
    }
    async signup(data: SignUpData): Promise<any> {
        return await this.authRepo.signup(data);
    }
    async getUserBasicInfo(): Promise<MemberBasicInfoResult> {
        return await this.authRepo.getUserBasicInfo();
    }
    async verifyEmail(payload: { email: string }): Promise<any> {
        return await this.authRepo.verifyEmail(payload);
    }
    async verifyOtpLogin(payload: VerifyData): Promise<any> {
        return await this.authRepo.verifyOtpLogin(payload);
    }
    async resetPassword(payload: { email: string; otp: string; password: string }): Promise<any> {
        return this.authRepo.resetPassword(payload);
    }
    async changePassword(payload: { oldPassword: string; newPassword: string }): Promise<any> {
        return this.authRepo.changePassword(payload);
    }
    async logout(): Promise<any> {
        return this.authRepo.logout();
    }
    async resendOtp(email: string): Promise<any> {
        return this.authRepo.resendOtp(email);
    }
    async verifyOtpRegister(payload: VerifyRegisterData): Promise<any> {
        return this.authRepo.verifyOtpRegister(payload);
    }
    async resendOtpRegister(email: string): Promise<any> {
        return this.authRepo.resendOtpRegister(email);
    }
}

export interface AuthUseCaseInterface {
    signin(data: SignInData): Promise<any>;
    signup(data: SignUpData): Promise<any>;
    getUserBasicInfo(): Promise<MemberBasicInfoResult>;
    resendOtp(email: string): Promise<any>;
    verifyOtpLogin(payload: VerifyData): Promise<any>;
    verifyOtpRegister(payload: VerifyRegisterData): Promise<any>;
    verifyEmail(payload: { email: string }): Promise<any>;
    resetPassword(payload: { email: string; otp: string; password: string }): Promise<any>;
    changePassword(payload: { oldPassword: string; newPassword: string }): Promise<any>;
    logout(): Promise<any>;
    resendOtpRegister(email: string): Promise<any>;
}
